import moment from "moment";
import sc from "../redux/actions/types/SelectionCriteriaTypes";
import {
  getPeriod,
  getApiPeriod,
} from "../../wizard/period-selector/redux/selectors/PeriodSelectionSelectors";
import {
  getArrivalCheckedMailProcessingCenters,
  getDepartureCheckedMailProcessingCenters,
  getDepartureCheckedOperator,
  getArrivalCheckedOperator,
  getDirections as getImpcDirections,
  getIsDirectionsSwitched as isImpcDirectionsSwitched,
} from "../../wizard/target-node-impc-selector/redux/selectors/PostalOperatorSelectors";
import { getDepartureCheckedMailProcessingCenters as getDepartureCheckedMrdMailProcessingCenters } from "../../wizard/target-node-mrd-impc-selector/redux/selectors/PostalOperatorSelectors";
import {
  getArrivalCheckedMailboxes,
  getDepartureCheckedMailboxes,
  getDirections as getMailboxDirections,
  getIsDirectionsSwitched as isMailboxDirectionsSwitched,
} from "../../wizard/target-node-mailbox-selector/redux/selectors/PostalOperatorSelectors";
import {
  getArrivalCheckedUnlocodes,
  getDepartureCheckedUnlocodes,
  getDirections as getUnlocodeDirections,
  getIsDirectionsSwitched as isUnlocodeDirectionsSwitched,
} from "../../wizard/target-node-unlocode-selector/redux/selectors/PostalOperatorSelectors";
import {
  getCheckedCarriers,
  getSelectedCarriers,
} from "../../wizard/target-node-carrier-selector/redux/selectors/CarrierSelectors";
import {
  getCheckedHandlers,
  getSelectedHandlers,
} from "../../wizard/target-node-handler-selector/redux/selectors/HandlerSelectors";
import {
  getSelectedReports,
  getCheckedReports,
} from "../../wizard/target-node-report-selector/redux/selectors/ReportsSelectors";
import { getCheckedOperatorUser } from "../../wizard/target-node-operator-user-selector/redux/selectors/OperatorUserSelector";
import { getSelectedProducts } from "../../wizard/product-selector/redux/selectors/MailClassesSelectors";
import {
  getAllSelectedLegs,
  getAllSelectedTransportModesByLeg,
} from "../../wizard/transport-mode-selector/redux/selectors/TransportModesSelectors";
import TargetNodeImpcWizardContainer from "../../wizard/common/components/TargetNodeImpcWizardContainer";
import TargetNodeOperatorWizardContainer from "../../wizard/common/components/TargetNodeOperatorWizardContainer";
import TargetNodeMrdImpcWizardContainer from "../../wizard/common/components/TargetNodeMrdImpcWizardContainer";
import TargetNodeCarrierWizardContainer from "../../wizard/common/components/TargetNodeCarrierWizardContainer";
import TargetNodeHandlerWizardContainer from "../../wizard/common/components/TargetNodeHandlerWizardContainer";
import TargetNodeMailboxWizardContainer from "../../wizard/common/components/TargetNodeMailboxWizardContainer";
import TargetNodeUnlocodeWizardContainer from "../../wizard/common/components/TargetNodeUnlocodeWizardContainer";
import PeriodSelectionWizardContainer from "../../wizard/period-selector/containers/PeriodSelectionWizardContainer";
import ProductSelectorWizardContainer from "../../wizard/product-selector/containers/ProductSelectorWizardContainer";
import TransportModeSelectorWizardContainer from "../../wizard/transport-mode-selector/containers/TransportModeSelectorWizardContainer";
import TargetNodeReportWizardContainer from "../../wizard/common/components/TargetNodeReportWizardContainer";
import TargetNodeOperatorUserWizardContainer from "../../wizard/common/components/TargetNodeOperatorUserWizardContainer";
import TargetNodeItemCriteriaWizardContainer from "../../wizard/common/components/TargetNodeItemCriteriaWizardContainer";

const DEFINITIONS = {};

const getSelectedValue = (arr1 = [], arr2 = []) => {
  const visibleItemCount = 2;
  const totalLength = arr1.length + arr2.length;
  const selectedValues = arr1
    .concat(arr2)
    .filter((v, i, a) => a.indexOf(v) === i)
    .slice(0, visibleItemCount)
    .map((v) => (typeof v === "string" ? v : v.label));

  if (
    selectedValues.length === visibleItemCount &&
    totalLength > visibleItemCount
  ) {
    selectedValues.push(`+${totalLength - visibleItemCount}`);
  }

  return selectedValues.join(", ");
};

DEFINITIONS[sc.SC001_02_03] = {
  routeName: "periodSelection",
  routePath: "period",
  component: PeriodSelectionWizardContainer,
  title: "period",
  icon: "clock-o",
  errorMessages: {
    noPeriodSelected: {
      code: "NO_PERIOD_SELECTED",
      message: "You must select a period to generate a report.",
    },
  },
  validate: (state, stack) => {
    const period = getPeriod(state);
    if (!period.startDate && !period.endDate) {
      stack.push(DEFINITIONS[sc.SC001_02_03].errorMessages.noPeriodSelected);
    }
  },
  showSelectedValue: true,
  getSelectedValue: (state) => {
    const period = getPeriod(state);
    const selectedDates = [];

    if (moment.isMoment(period.startDate)) {
      selectedDates.push(period.startDate.format("DD/MM/YYYY"));
    }

    if (moment.isMoment(period.endDate)) {
      const startDate = selectedDates[0];
      const endDate = period.endDate.format("DD/MM/YYYY");
      if (startDate !== endDate) {
        selectedDates.push(endDate);
      }
    }

    return selectedDates.join(" - ");
  },
  getSelectionCriteriaDto: (selectionCriteria) => ({
    period: getApiPeriod(selectionCriteria),
    dateField: selectionCriteria.period.dateField,
    requestMode: "SYNC",
  }),
};

DEFINITIONS[sc.SC001_02_03_mrd] = {
  routeName: "periodSelection",
  routePath: "period",
  component: PeriodSelectionWizardContainer,
  title: "period",
  icon: "clock-o",
  errorMessages: {
    noPeriodSelected: {
      code: "NO_PERIOD_SELECTED",
      message: "You must select a period to generate a report.",
    },
  },
  validate: (state, stack) => {
    const period = getPeriod(state);
    if (!period.startDate && !period.endDate) {
      stack.push(DEFINITIONS[sc.SC001_02_03].errorMessages.noPeriodSelected);
    }
  },
  showSelectedValue: true,
  getSelectedValue: (state) => {
    const period = getPeriod(state);
    const selectedDates = [];

    if (moment.isMoment(period.startDate)) {
      selectedDates.push(period.startDate.format("DD/MM/YYYY"));
    }

    if (moment.isMoment(period.endDate)) {
      const startDate = selectedDates[0];
      const endDate = period.endDate.format("DD/MM/YYYY");
      if (startDate !== endDate) {
        selectedDates.push(endDate);
      }
    }
    return selectedDates.join(" - ");
  },
  getSelectionCriteriaDto: (selectionCriteria) => ({
    period: getApiPeriod(selectionCriteria),
    dateField: selectionCriteria.period.dateField,
    mrdLikeStatus: selectionCriteria.customFilter.mrdLikeStatus,
  }),
};

DEFINITIONS[sc.SC010] = {
  routeName: "impcSelection",
  routePath: "impc",
  component: TargetNodeImpcWizardContainer,
  title: "operator/impc",
  icon: "map-marker",
  errorMessages: {
    noDepartureMailProcessingCentersSelected: {
      code: "NO_DEPARTURE_MAIL_PROCESSING_CENTERS_SELECTED",
      message:
        "You must select at least one departure mail processing center to generate a report.",
    },
    noArrivalMailProcessingCentersSelected: {
      code: "NO_ARRIVAL_MAIL_PROCESSING_CENTERS_SELECTED",
      message:
        "You must select at least one arrival mail processing center to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedMailProcessingCenters(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC010].errorMessages
          .noDepartureMailProcessingCentersSelected
      );
    }
    if (getArrivalCheckedMailProcessingCenters(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC010].errorMessages
          .noArrivalMailProcessingCentersSelected
      );
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(
      getDepartureCheckedMailProcessingCenters(state),
      getArrivalCheckedMailProcessingCenters(state)
    ),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices:
      selectionCriteria.departureCheckedMailProcessingCenters,
    destinationExchangeOffices:
      selectionCriteria.arrivalCheckedMailProcessingCenters,
  }),
  getDirections: (state) => getImpcDirections(state),
  isDirectionsSwitched: (state) => isImpcDirectionsSwitched(state),
};

DEFINITIONS[sc.SC010_COMPARATIVE] = {
  ...DEFINITIONS[sc.SC010],
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices:
      selectionCriteria.departureCheckedMailProcessingCenters,
    destinationExchangeOffices:
      selectionCriteria.arrivalCheckedMailProcessingCenters,
    referencePeriod: getApiPeriod(selectionCriteria),
  }),
};

DEFINITIONS[sc.SC011] = {
  routeName: "operatorSelection",
  routePath: "operator",
  component: TargetNodeOperatorWizardContainer,
  title: "operator",
  icon: "map-marker",
  errorMessages: {
    noDepartureOperatorsSelected: {
      code: "NO_DEPARTURE_OPERATORS_SELECTED",
      message:
        "You must select at least one departure operator to generate a report.",
    },
    noArrivalOperatorssSelected: {
      code: "NO_ARRIVAL_OPERATORS_SELECTED",
      message:
        "You must select at least one arrival operator to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedOperator(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC011].errorMessages.noDepartureOperatorsSelected
      );
    }
    if (getArrivalCheckedOperator(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC011].errorMessages.noArrivalOperatorssSelected
      );
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(
      getDepartureCheckedOperator(state),
      getArrivalCheckedOperator(state)
    ),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices: selectionCriteria.departureCheckedOperators,
    destinationExchangeOffices: selectionCriteria.arrivalCheckedOperators,
  }),
  getDirections: (state) => getImpcDirections(state),
  isDirectionsSwitched: (state) => isImpcDirectionsSwitched(state),
};

DEFINITIONS[sc.SC010_OVERVIEW] = {
  ...DEFINITIONS[sc.SC010],
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices:
      selectionCriteria.departureCheckedMailProcessingCenters,
    destinationExchangeOffices:
      selectionCriteria.arrivalCheckedMailProcessingCenters,
    excludeEtoes: selectionCriteria.checkedTrafficOperators.find(
      (value) => value === "excludeEtoes"
    )
      ? true
      : false,
    excludeInternalTraffic: selectionCriteria.checkedTrafficOperators.find(
      (value) => value === "excludeInternalTraffic"
    )
      ? true
      : false,
  }),
};

DEFINITIONS[sc.SC0011_TRACKED_ITEMS_IN_PREDES_ETOE] = {
  ...DEFINITIONS[sc.SC011],
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices: selectionCriteria.departureCheckedOperators,
    destinationExchangeOffices: selectionCriteria.arrivalCheckedOperators,
    excludeEtoes: selectionCriteria.customFilter.excludeEtoes,
  }),
};

DEFINITIONS[sc.SC011_EDI_EXCHANGE] = {
  ...DEFINITIONS[sc.SC011],
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices: selectionCriteria.departureCheckedOperators,
    destinationExchangeOffices: selectionCriteria.arrivalCheckedOperators,
    allOrigin: selectionCriteria.customFilter.allOrigin,
    allDestination: selectionCriteria.customFilter.allDestination,
    showSending: selectionCriteria.customFilter.showSending,
    showReceiving: selectionCriteria.customFilter.showReceiving,
    showMailBoxes: selectionCriteria.customFilter.showMailBoxes,
  }),
};
DEFINITIONS[sc.SC011_EDI_EXCHANGE_706] = {
  ...DEFINITIONS[sc.SC011],
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices: selectionCriteria.departureCheckedOperators,
    destinationExchangeOffices: selectionCriteria.arrivalCheckedOperators,
    allOrigin: selectionCriteria.customFilter.allOrigin,
    allDestination: selectionCriteria.customFilter.allDestination,
  }),
};

DEFINITIONS[sc.SC011NA] = {
  routeName: "operatorSelectionNoArrival",
  routePath: "operator-no-arrival",
  component: TargetNodeOperatorWizardContainer,
  title: "operator",
  icon: "map-marker",
  errorMessages: {
    noDepartureOperatorsSelected: {
      code: "NO_DEPARTURE_OPERATORS_SELECTED",
      message:
        "You must select at least one departure operator to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedOperator(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC011NA].errorMessages.noDepartureOperatorsSelected
      );
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(getDepartureCheckedOperator(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices: selectionCriteria.departureCheckedOperators,
    destinationExchangeOffices: [],
  }),
};

DEFINITIONS[sc.SC011T] = {
  ...DEFINITIONS[sc.SC011NA],
  getSelectionCriteriaDto: (selectionCriteria) => ({
    ...DEFINITIONS[sc.SC011NA].getSelectionCriteriaDto(selectionCriteria),
    excludeEtoes: selectionCriteria.checkedTrafficOperators.find(
      (value) => value === "excludeEtoes"
    )
      ? true
      : false,
    excludeInternalTraffic: selectionCriteria.checkedTrafficOperators.find(
      (value) => value === "excludeInternalTraffic"
    )
      ? true
      : false,
  }),
};

DEFINITIONS[sc.SC021] = {
  routeName: "unlocodeSelection",
  routePath: "unlocode",
  component: TargetNodeUnlocodeWizardContainer,
  title: "Location",
  icon: "map-marker",
  errorMessages: {
    noDepartureUnlocodeSelected: {
      code: "NO_DEPARTURE_UNLOCODE_SELECTED",
      message:
        "You must select at least one departure Unlocode to generate a report.",
    },
    noArrivalUnlocodeSelected: {
      code: "NO_ARRIVAL_UNLOCODE_SELECTED",
      message:
        "You must select at least one arrival Unlocode to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedUnlocodes(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC021].errorMessages.noDepartureUnlocodeSelected
      );
    }
    if (getArrivalCheckedUnlocodes(state).length < 1) {
      stack.push(DEFINITIONS[sc.SC021].errorMessages.noArrivalUnlocodeSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(
      getDepartureCheckedUnlocodes(state),
      getArrivalCheckedUnlocodes(state)
    ),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originUnlocodes: selectionCriteria.departureCheckedUnlocodes,
    destinationUnlocodes: selectionCriteria.arrivalCheckedUnlocodes,
  }),
  getDirections: (state) => getUnlocodeDirections(state),
  isDirectionsSwitched: (state) => isUnlocodeDirectionsSwitched(state),
};

DEFINITIONS[sc.SC030] = {
  routeName: "productSelection",
  routePath: "product",
  component: ProductSelectorWizardContainer,
  title: "Despatch Type",
  icon: "bookmark",
  errorMessages: {
    noProductSelected: {
      code: "NO_PRODUCT_SELECTED",
      message: "You must select at least one product to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getSelectedProducts(state).length < 1) {
      stack.push(DEFINITIONS[sc.SC030].errorMessages.noProductSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedProducts(state).join(", "),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    mailCategoriesWithSubClasses:
      selectionCriteria.mailCategoriesWithSubClasses,
  }),
};

DEFINITIONS[sc.SC060] = {
  routeName: "edimailboxSelection",
  routePath: "edi-mailbox",
  component: TargetNodeMailboxWizardContainer,
  title: "operator/mailbox",
  icon: "map-marker",
  errorMessages: {
    noDepartureEdiMailboxSelected: {
      code: "NO_DEPARTURE_EDI_MAILBOX_SELECTED",
      message:
        "You must select at least one departure EDI mailbox to generate a report.",
    },
    noArrivalEdiMailboxSelected: {
      code: "NO_ARRIVAL_EDI_MAILBOX_SELECTED",
      message:
        "You must select at least one arrival EDI mailbox to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedMailboxes(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC060].errorMessages.noDepartureEdiMailboxSelected
      );
    }
    if (getArrivalCheckedMailboxes(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC060].errorMessages.noArrivalEdiMailboxSelected
      );
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(
      getDepartureCheckedMailboxes(state),
      getArrivalCheckedMailboxes(state)
    ),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originMailboxes: selectionCriteria.departureCheckedMailboxes,
    destinationMailboxes: selectionCriteria.arrivalCheckedMailboxes,
  }),
  getDirections: (state) => getMailboxDirections(state),
  isDirectionsSwitched: (state) => isMailboxDirectionsSwitched(state),
};

DEFINITIONS[sc.SC070] = {
  routeName: "transportModeSelection",
  routePath: "transport-mode",
  component: TransportModeSelectorWizardContainer,
  title: "Transport mode",
  icon: "bookmark",
  errorMessages: {
    noTransportModeSelected: {
      code: "NO_TRANSPORT_MODE_SELECTED",
      message:
        "You must select at least one transport mode to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (
      getAllSelectedTransportModesByLeg(state).some(
        (tm) => tm.transportModes.length
      ) === false
    ) {
      stack.push(DEFINITIONS[sc.SC070].errorMessages.noTransportModeSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getAllSelectedLegs(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    legsWithTransportModes: selectionCriteria.legsWithTransportModes,
  }),
};

DEFINITIONS[sc.SC080] = {
  routeName: "mrdImpcSelection",
  routePath: "mrd-impc",
  component: TargetNodeMrdImpcWizardContainer,
  title: "Mrd impc",
  icon: "map-marker",
  errorMessages: {
    noDepartureMailProcessingCentersSelected: {
      code: "NO_DEPARTURE_MAIL_PROCESSING_CENTERS_SELECTED",
      message:
        "You must select at least one departure mail processing center to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedMrdMailProcessingCenters(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC080].errorMessages
          .noDepartureMailProcessingCentersSelected
      );
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(getDepartureCheckedMrdMailProcessingCenters(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices:
      selectionCriteria.departureCheckedMrdMailProcessingCenters,
    destinationExchangeOffices: [],
  }),
};

DEFINITIONS[sc.SC080_mrdHandlerId] = {
  routeName: "mrdImpcSelection",
  routePath: "mrd-impc",
  component: TargetNodeMrdImpcWizardContainer,
  title: "Mrd impc",
  icon: "map-marker",
  errorMessages: {
    noDepartureMailProcessingCentersSelected: {
      code: "NO_DEPARTURE_MAIL_PROCESSING_CENTERS_SELECTED",
      message:
        "You must select at least one departure mail processing center to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getDepartureCheckedMrdMailProcessingCenters(state).length < 1) {
      stack.push(
        DEFINITIONS[sc.SC080].errorMessages
          .noDepartureMailProcessingCentersSelected
      );
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) =>
    getSelectedValue(getDepartureCheckedMrdMailProcessingCenters(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    originExchangeOffices:
      selectionCriteria.departureCheckedMrdMailProcessingCenters,
    mrdHandlerId: null,
    carrierCode: "Total",
    destinationExchangeOffices: [],
  }),
};

DEFINITIONS[sc.SC090] = {
  routeName: "carrierSelection",
  routePath: "carrier",
  component: TargetNodeCarrierWizardContainer,
  title: "Carrier",
  icon: "map-marker",
  errorMessages: {
    noCarriersSelected: {
      code: "NO_CARRIERS_SELECTED",
      message: "You must select at least one carrier to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getCheckedCarriers(state).length < 1) {
      stack.push(DEFINITIONS[sc.SC090].errorMessages.noCarriersSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getSelectedCarriers(state)),
  getSelectionCriteriaDto: (selectionCriteria, useLabels) => ({
    carriers: useLabels
      ? selectionCriteria.checkedCarrierLabels
      : selectionCriteria.checkedCarriers,
  }),
};

DEFINITIONS[sc.SC091] = {
  routeName: "handlerSelection",
  routePath: "handler",
  component: TargetNodeHandlerWizardContainer,
  title: "Handler",
  icon: "map-marker",
  errorMessages: {
    noHandlersSelected: {
      code: "NO_HANDLERS_SELECTED",
      message: "You must select at least one handler to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getCheckedHandlers(state).length < 1) {
      stack.push(DEFINITIONS[sc.SC091].errorMessages.noHandlersSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getSelectedHandlers(state)),
  getSelectionCriteriaDto: (selectionCriteria, useLabels) => ({
    handlers: useLabels
      ? selectionCriteria.checkedHandlerLabels
      : selectionCriteria.checkedHandlers,
  }),
};

DEFINITIONS[sc.SC050] = {
  routeName: "operatorUserSelection",
  routePath: "operator-user",
  component: TargetNodeOperatorUserWizardContainer,
  title: "Operator/User",
  icon: "map-marker",
  errorMessages: {
    noOperatorUserSelected: {
      code: "NO_OPERATOR_USER_SELECTED",
      message:
        "You must select at least one operator/user to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getCheckedOperatorUser(state).length < 1) {
      stack.push(DEFINITIONS[sc.SC050].errorMessages.noOperatorUserSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getCheckedOperatorUser(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    users: selectionCriteria.checkedOperatorUser,
  }),
};

DEFINITIONS[sc.SC051] = {
  routeName: "reportsSelection",
  routePath: "reports",
  component: TargetNodeReportWizardContainer,
  title: "Reports",
  icon: "map-marker",
  errorMessages: {
    noReportsSelected: {
      code: "NO_REPORTS_SELECTED",
      message: "You must select at least one report to generate a report.",
    },
  },
  validate: (state, stack) => {
    if (getCheckedReports(state).length < 1) {
      stack.push(DEFINITIONS[sc.SC051].errorMessages.noReportsSelected);
    }
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getSelectedReports(state)),
  getSelectionCriteriaDto: (selectionCriteria, useLabels) => ({
    modules: useLabels
      ? selectionCriteria.checkedReportsLabels
      : selectionCriteria.checkedReports,
  }),
};

DEFINITIONS[sc.SC100] = {
  routeName: "itemsSelection",
  routePath: "items",
  component: TargetNodeItemCriteriaWizardContainer,
  title: "Item Criteria",
  icon: "map-marker",
  errorMessages: {
    noItemsSelected: {
      code: "NO_ITEMS_SELECTED",
      message: "You must select at least one item to generate a report.",
    },
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getSelectedReports(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    itemPrefixes: selectionCriteria.checkedFilterOnItems,
    itemsMissingEvents: selectionCriteria.checkedOnlyShowItems,
    spaceSeparatedItemIds: selectionCriteria.manualEntryText,
    filterOnImpcs: selectionCriteria.checkedFilterOnImpc,
    filterOnDespatchTypes: selectionCriteria.checkedFilterOnDespatch,
  }),
};

DEFINITIONS[sc.SC100_OVERVIEW] = {
  routeName: "itemsSelection",
  routePath: "items",
  component: TargetNodeItemCriteriaWizardContainer,
  title: "Item Criteria",
  icon: "map-marker",
  errorMessages: {
    noItemsSelected: {
      code: "NO_ITEMS_SELECTED",
      message: "You must select at least one item to generate a report.",
    },
  },
  showSelectedValue: false,
  getSelectedValue: (state) => getSelectedValue(getSelectedReports(state)),
  getSelectionCriteriaDto: (selectionCriteria) => ({
    itemPrefixes: selectionCriteria.checkedFilterOnItems,
    itemsMissingEvents: selectionCriteria.checkedOnlyShowItems,
    itemsWithEvents: selectionCriteria.checkedOnlyShowItemsWith,
    spaceSeparatedItemIds: selectionCriteria.manualEntryText,
    spaceSeparatedSuffixes: selectionCriteria.spaceSeparatedSuffixes,
    filterOnImpcs: selectionCriteria.checkedFilterOnImpc,
    filterOnDespatchTypes: selectionCriteria.checkedFilterOnDespatch,
  }),
};

export default DEFINITIONS;
